import { piniaPageBrand } from '@stores/usePageBrandStore';
import { createApp } from 'vue';
import PageBrandMapView from './views/PageBrandMapView.vue';

export const initPageBrandMap = () => {
  if (!document.getElementById('brand-details-map-app')) {
    return;
  }

  createApp(PageBrandMapView)
    .use(piniaPageBrand)
    .mount('#brand-details-map-app');
};
